import type { ReactNode } from "react";
import "./Snackbar.scss";
import IconCross from "@/shared/components/generic/icons/IconCross";
import IconButton from "@/shared/components/generic/button/IconButton";
import { Level, Size } from "@/shared/components/generic/UiEnums";
import type { SnackbarProps } from "@/shared/components/generic/snackbar/SnackbarProps";

export default function Snackbar({
  message,
  visible = true,
  icon,
  showCloseIcon = false,
  style = "DEFAULT",
  onClose = (): void => {
    return;
  },
  animation = true,
}: SnackbarProps): ReactNode {
  return (
    <div
      className={`snackbar style-${style.toLowerCase()} ${animation ? "animation" : ""} ${visible ? "enter" : "leave"}`}
    >
      {icon?.({})}
      <div className="message">{message}</div>
      {showCloseIcon && (
        <IconButton
          icon={IconCross}
          onClick={onClose}
          size={Size.SMALL}
          level={Level.TERTIARY}
        />
      )}
    </div>
  );
}
